import { render, staticRenderFns } from "./UsersLogs.vue?vue&type=template&id=e48e1500&"
import script from "./UsersLogs.vue?vue&type=script&lang=js&"
export * from "./UsersLogs.vue?vue&type=script&lang=js&"
import style0 from "./UsersLogs.vue?vue&type=style&index=0&id=e48e1500&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports